import React, { useEffect } from 'react';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import '../styles/Maincomponent.css';
import logo from '../styles/logo.png'; // Ensure this file exists


const Maincomponent = () => {
  useEffect(() => {
    const userConsent = Cookies.get('userConsent');
    if (userConsent) {
      console.log('User has given consent for cookies.');
      // Perform actions that require user consent
    } else {
      console.log('User has not given consent for cookies.');
      // Handle the case where user has not given consent
    }
  }, []);

  return (
    <div className="navbar">
    <img src={logo} alt="AI ASAP Solutions Logo" className="logo" />
    <div>
      <Link to="/">Home</Link>
      <Link to="/products">Products</Link>
      <Link to="/about">About</Link>
      <Link to="/contact">Contact</Link>
    </div>
  </div>
  );
};

export default Maincomponent;